/**
 * Browser-tab icon for a TEST or DEV system: a 64x64 rounded orange square with a bold dark "T".
 * Swapped in by `SystemEnvironmentService.applyToDocument()` so the marking shows even on a tab
 * too narrow to show its title.
 *
 * The fill `#fd7e14` is `$orange` and the letter `#212529` is `$gray-900` from
 * `styles/_colour.scss` - repeated here because SCSS variables cannot reach a data URL.
 */
export const TestSystemFavicon =
  'data:image/svg+xml,' +
  '%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20viewBox%3D%270%200%2064%2064%27%3E' +
  '%3Crect%20width%3D%2764%27%20height%3D%2764%27%20rx%3D%2712%27%20fill%3D%27%23fd7e14%27%2F%3E' +
  '%3Ctext%20x%3D%2732%27%20y%3D%2747%27%20font-family%3D%27Arial%2CHelvetica%2Csans-serif%27' +
  '%20font-size%3D%2744%27%20font-weight%3D%27700%27%20text-anchor%3D%27middle%27%20fill%3D%27%23212529%27%3E' +
  'T%3C%2Ftext%3E' +
  '%3C%2Fsvg%3E';
